import React, { type ReactNode } from 'react'
import { DecoratorNode, type NodeKey, type LexicalNode, type LexicalEditor, type SerializedLexicalNode } from 'lexical'
import { Translations } from '../../../../shared/i18n/Translations'
import { IconButton } from '../../ui/IconButton'

export type SerializedCopyButtonNode = SerializedLexicalNode & { type: 'copy-button' }
export function isSerializedCopyButtonNode(node: SerializedLexicalNode): node is SerializedCopyButtonNode {
    return node.type === 'copy-button'
}

export class CopyButtonNode extends DecoratorNode<ReactNode> {
    static getType(): string {
        return 'copy-button'
    }

    static clone(node: CopyButtonNode): CopyButtonNode {
        return new CopyButtonNode(node.__key)
    }

    static importJSON(_: SerializedCopyButtonNode) {
        return new CopyButtonNode()
    }

    constructor(key?: NodeKey) {
        super(key)
    }

    createDOM(): HTMLElement {
        return document.createElement('span')
    }

    updateDOM(): false {
        return false
    }

    decorate(_editor: LexicalEditor): ReactNode {
        return <CopyButton />
    }

    exportJSON(): SerializedCopyButtonNode {
        return { version: 0, type: 'copy-button' }
    }

    isIsolated() {
        return true
    }
}

export function $createCopyButtonNode(): CopyButtonNode {
    return new CopyButtonNode()
}

export function $isCopyButtonNode(node: LexicalNode | null | undefined): node is CopyButtonNode {
    return node instanceof CopyButtonNode
}

export function CopyButton() {
    return (
        <>
            <IconButton
                iconName="copy"
                size="tiny"
                border={false}
                tooltip={Translations.t('appcore:ZapBot.copyAnswer')}
            />
        </>
    )
}
